import { styled, Box } from "@mui/material";

export const SystemTrayItemWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "40px",
    padding: "0 10px",
    borderRadius: "3px",
    fontSize: "12px",
    position: "relative",
    marginRight: "2px",
    width: "20px",
});